import "./whatsapp.css";
import whatsappIcon from "../../Photos/Icons/whatapp.png";
const Whatsapp = () => {
  const handleClick = () => {
    window.open(
      "https://api.whatsapp.com/send?phone=9779867733552&text=I%20am%20contacting%20you%20regarding%20an%20inquiry%20about%20Scaleup%20Academy.%0AName:%0ACourses:",
      "_blank" // opens in a new tab
    );
  };

  return (
    <div onClick={handleClick} className="whatsappbox" role="button">
      <img src={whatsappIcon} alt="Whatsapp" />
    </div>
  );
};

export default Whatsapp;
